import { configureStore } from '@reduxjs/toolkit'
import  generalSlice from './features/general/generalSlice';
import  darkMode from './features/general/generalSlice';
import projectDetailSlice from './features/projectDetail/projectDetailSlice';
import projectsSlice from './features/projects/projectsSlice';
import taskDetailSlice from './features/taskDetail/taskDetailSlice';
import tasksSlice from './features/tasks/tasksSlice';
import usersSlice from './features/users/usersSlice';

export const store = configureStore({
  reducer: {general : generalSlice, dark : darkMode, projectDetail: projectDetailSlice,projects:projectsSlice, tasks:tasksSlice, taskDetail:taskDetailSlice, users:usersSlice },
})